import React, { useEffect } from 'react';
import UpdateProfileForm from './components/UpdateProfileForm';
import { useNavigate } from 'react-router-dom';
import { useSuperadminAuth } from '../../contexts/SuperadminAuthContext';

const SuperadminProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useSuperadminAuth();

  // Redirect if not authenticated
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/superadmin/auth/login', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  // Don't render anything while checking auth or if not authenticated
  if (loading || !isAuthenticated) {
    return null;
  }

  return <UpdateProfileForm />;
};

export default SuperadminProfilePage;
